import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../pages/SignIn";
import Dashboard from "../pages/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login";
import ErrorBoundary from "../components/ErrorBoundary";
import Patients from "../pages/Patients";
import ApiConfigurations from "../pages/ApiConfigurations";
import PatientLogs from "../pages/PatientLogs";
import McoPatPlanConfigurations from "../pages/McoPatPlanConfigurations";
import Queries from "../pages/Queries";
import Events from "../pages/Events";
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ErrorBoundary>
            <SignIn />
          </ErrorBoundary>
        }
      />
      <Route
        path="/login"
        element={
          <ErrorBoundary>
            <Login />
          </ErrorBoundary>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/patients"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Patients />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/api-configurations"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <ApiConfigurations />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <PatientLogs />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/mco-patplan-configurations"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <McoPatPlanConfigurations />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/queries"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Queries />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedRoute>
            <ErrorBoundary>
              <Events />
            </ErrorBoundary>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};
export default AppRoutes;
